import { 
    gql, 
    useMutation 
} from "@apollo/client";
import { 
    ResetMerchantPasswordAdminMutationMutation,
    ResetMerchantPasswordAdminMutationMutationVariables 
} from "../../../../../schemaTypes";

export const RESET_MERCHANT_PASSWORD_ADMIN_MUTATION = gql`
  mutation ResetMerchantPasswordAdminMutation($id: String!) {
    resetMerchantPasswordAdmin(id: $id) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submit: (
        values: ResetMerchantPasswordAdminMutationMutationVariables
      ) => Promise<{
        errors: { path: string; message: string }[] | null;
        message: string | null;
      } | null>;
      loading: boolean;
      error?: Error;
    }
  ) => React.ReactElement | null;
}

export const ResetMerchantPasswordAdminController: React.FC<Props> = ({ children }) => {
  const [resetMerchantPasswordAdmin, { loading, error }] = useMutation<
    ResetMerchantPasswordAdminMutationMutation,
    ResetMerchantPasswordAdminMutationMutationVariables
  >(RESET_MERCHANT_PASSWORD_ADMIN_MUTATION);

  const submit = async (values: ResetMerchantPasswordAdminMutationMutationVariables) => {
    try {
      const { data } = await resetMerchantPasswordAdmin({ variables: values });
      if (data?.resetMerchantPasswordAdmin) {
        return {
          errors: data.resetMerchantPasswordAdmin.errors
            ? data.resetMerchantPasswordAdmin.errors
                .filter((e): e is { path: string; message: string } => e !== null)
                .map(({ path, message }) => ({ path, message }))
            : null,
          message: data.resetMerchantPasswordAdmin.message ?? null,
        };
      }
      return null;
    } catch {
      return null;
    }
  };

  return children({ submit, loading, error });
};